import axios from "axios";
import { API } from "./api";

export const CLI_TOKEN_KEY = "pgp_cli_token";

const clienteApi = axios.create({ baseURL: API });

clienteApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(CLI_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

clienteApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const sospeso = err.response?.status === 403 && String(err.response?.data?.detail || "").startsWith("Account sospeso");
    if ((err.response?.status === 401 || sospeso) && localStorage.getItem(CLI_TOKEN_KEY)) {
      localStorage.removeItem(CLI_TOKEN_KEY);
      if (!window.location.pathname.startsWith("/cliente/login")) window.location.href = "/cliente/login";
    }
    return Promise.reject(err);
  }
);

export default clienteApi;
